import React, { useState, useEffect } from "react";
import "./resume.css";
import pdfimage from "./images/pdf.png";
import docimage from "./images/doc.png";
import Skeleton from "@mui/material/Skeleton";
import { BlobServiceClient } from "@azure/storage-blob";
import { FilePicker } from "react-file-picker";
import {  pdfjs } from "react-pdf";
import {
  NotificationManager,
} from "react-notifications";

import { styled} from "@mui/styles";
import Dialog from "@mui/material/Dialog";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import profileResponse from "../../../apis/profile/profileById";
import updateProfile from "../../../apis/profile/updateProfile";

const stylesSX = {
  buttonAlignForRemove: {
    padding: '32px !important',
  },
  bodyForRemove: {
    padding: '26px 24px 0px 24px !important',
    marginTop: '0px !important',
  },
};




// Separate styled DialogContent
const DialogContent = styled(MuiDialogContent)(({ theme }) => ({
  // Add padding or styles here if needed
  // padding: '0px 30px',
}));

// Separate styled DialogActions
const DialogActions = styled(MuiDialogActions)(({ theme }) => ({
  margin: 0,
  padding: '16px',
}));

const Resume = ({ setLastUpdate, userId}) => {
  const jsonConfig = require("../../../Config.json");
  const [resumeData, setResumeData] = useState("");
  const [isResumeDataAvailable, setIsResumeDataAvailable] = useState(false);
  const [openDeleteDialogue, setOpenDeleteDialogue] = useState(false);
  const [fileType, setFileType] = useState("");
  const [loadingController, setLoadingController] = useState(false);
  const [openLinkedIn, setOpenLinkedIn] = useState(false);
  const [urlValue, setUrlValue] = useState("");
  const [name, setName] = useState("");

  const getResumeData = async () => {
    // const authResponse = await instance.acquireTokenSilent({
    //   ...loginRequest,
    //   account: account,
    // });

    try {
      const getResumeResponse = await profileResponse(userId);

      setLastUpdate(getResumeResponse.data.data[0].lastUpdated)
      setName(getResumeResponse.data.data[0].user.firstName);
     
      if (
        getResumeResponse.data.data[0].resumeUrl ||
        getResumeResponse.data.data[0].referralResumeUrl
      ) {
        if( getResumeResponse.data.data[0].resumeUrl){
          let index = getResumeResponse.data.data[0].resumeUrl.lastIndexOf(".");
          let type = getResumeResponse.data.data[0].resumeUrl.substr(index + 1);
          setFileType(type);
        }else{
          let index = getResumeResponse.data.data[0].referralResumeUrl.lastIndexOf(".");
          let type = getResumeResponse.data.data[0].referralResumeUrl.substr(index + 1);
          setFileType(type);
        }
       
        setResumeData(getResumeResponse.data.data[0]);
        setIsResumeDataAvailable(true);
        setLoadingController(true);
      } else {
        setIsResumeDataAvailable(false);
        setLoadingController(true);
      }
      if (
        !getResumeResponse.data.data[0].videoIntroUrl == null ||
        !getResumeResponse.data.data[0].videoIntroUrl === ""
      ) {

      }
    } catch (error) {
      setIsResumeDataAvailable(false);
      setResumeData("");
      setLoadingController(true);
    }
  };
  const downloadResume = async (event, url) => {
    window.open(url, "_blank");
  };
  const removeResume = async () => {
    var dt = new Date();
    var resumeDataRequest = {
      resumeUrl: "",
      resumeName: "",
      lastUpdated: dt,
    };
    try {
      const payload = {
        id: userId,
        data: resumeDataRequest,
      }
      await updateProfile(payload);
      NotificationManager.success("Resume deleted", "Success",10000);
      await getResumeData();
      setIsResumeDataAvailable(false);
      setOpenDeleteDialogue(false);
    } catch (error) { }
  };

  const uploadToBlobStorage = async (blob) => {
    let firstName = ''
    try {
      const getResumeResponse = await profileResponse(userId);
      firstName = getResumeResponse.data.data[0].user.firstName;
    } catch (error) {
      setIsResumeDataAvailable(false);
      setResumeData("");
      setLoadingController(true);
    }
    const sas = jsonConfig.sasToken;
    const bsClient = new BlobServiceClient(
      `${jsonConfig.ctResourcesCdn + sas}`

    );
    let blobValue = blob.name.split(".")
    var v = blobValue[blobValue.length - 1];
    var c = firstName + "_Resume." + v;
    const containerClient = bsClient.getContainerClient("resume");
    const blobName = userId + "/" + c;
    const url = `${jsonConfig.ctResourcesCdn}/resume/${blobName}`;
    const blobClient = containerClient.getBlockBlobClient(blobName);
    await blobClient.uploadBrowserData(blob);
    var dt = new Date();
    const resumeDataRequest = {
      resumeUrl: url,
      resumeName: firstName + "_Resume",
      lastUpdated: dt,
    };
    try {
      const payload = {
        id: userId,
        data: resumeDataRequest,
      }
      await updateProfile(payload);
    } catch (error) {
      NotificationManager.error("Resume updation failed", "Error",10000);
      
    }

    
    await getResumeData();
    NotificationManager.success("Resume uploaded", "Success",10000);
  };
  const filePickerOnChange = async (file) => {
    await uploadToBlobStorage(file);
  };

  const closeLinkedModal = () => {
    setOpenLinkedIn(false);
    setUrlValue("")
  };

  const closeDeleteDialogue = () => {
    setOpenDeleteDialogue(false);
  };

  useEffect(() => {
    getResumeData();
    pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
  }, [userId]);
  return (
    <>
      {loadingController ? (
        <>
          <div className="powres_card mt_10 powres_box " >
            <div className="row">
             
              <p className="mn_semibold fs-14 text-center f-color">Resume</p>
             

              {isResumeDataAvailable ? (

                <>
                  <div className="df mt_10 text-center"style={{justifyContent:"center"}}>
                    {fileType === "pdf" ? (
                      <div>
                        <img src={pdfimage} alt="" />
                      </div>
                    ) : (
                      <div>
                        <img src={docimage} alt="" />
                      </div>
                    )}
                    <div
                      className="fs-semi-bold fs-14 upload_text br_word"
                      onClick={(e) => { resumeData.resumeUrl ? downloadResume(e, resumeData.resumeUrl) : downloadResume(e, resumeData.referralResumeUrl) }}
                    >
                      {`${name}_Resume.${fileType}`}
                    </div>
                  </div>
                </>
              ) : 
               <p className="fs-regular fs-12 f-color mt_30 text-center">
                (Allowed file types: .pdf, .docx)
              </p> 
              }

              {isResumeDataAvailable && resumeData.resumeUrl ? (
                ""
              ) : (
                <>
                  <FilePicker
                    extensions={["pdf", "docx"]}
                    onChange={filePickerOnChange}
                    onError={(errMsg) => {
                      NotificationManager.error(errMsg, "Error",10000);
                    }}
                  >
                    <button className="btn-resume-testimonial cp fs_manrope_12_btn mt_70">
                      Upload Resume
                    </button>
                  </FilePicker>
                </>
              )}
              {isResumeDataAvailable && resumeData.resumeUrl ? (
                <>
                  <FilePicker
                    extensions={["pdf", "docx"]}
                    onChange={filePickerOnChange}
                    onError={(errMsg) => {
                      NotificationManager.error(errMsg, "Error",10000);
                    }}
                  >
                    <button className="btn-resume-testimonial mt_20 cp fs_manrope_12_btn">
                      Replace Resume
                    </button>
                  </FilePicker>
                </>
              ) : (
                ""
              )}
              {isResumeDataAvailable && resumeData.resumeUrl ? (
                <>
                  <button
                    className=" btn-resume-testimonial mt_10 cp fs_manrope_12_btn"
                    onClick={() => setOpenDeleteDialogue(true)}
                  >
                    Remove Resume
                  </button>
                </>
              ) : (
                ""
              )}
            </div>
            <Dialog
              open={openDeleteDialogue}
              onClose={closeDeleteDialogue}
              aria-labelledby="customized-dialog-title"
            >
              <DialogContent
                className="removemodal_responsive" sx={stylesSX.bodyForRemove}
              >
                <div className="text-center fs-semi-bold f-color fs-18">
                  Are you sure want to delete ?
                </div>
              </DialogContent>
              <DialogActions
                className="responsiveRemove_Modal_button"
                sx={stylesSX.bodyForRemove}
              >
                <div className="remove_modal">
                  <button
                    type="button"
                    className="btn_remove btn-skill cp"
                    onClick={closeDeleteDialogue}
                  >
                    No
                  </button>
                  <button
                    type="button"
                    className="btn2 btn_powres ml_5 cp"
                    onClick={removeResume}
                  >
                    Yes
                  </button>
                </div>
              </DialogActions>
            </Dialog>

            <Dialog
              open={openLinkedIn}
              onClose={closeLinkedModal}
              aria-labelledby="customized-dialog-title"
              className="linkedin-modal-dialog"
              maxWidth="sm"
            >
              <DialogContent sx={stylesSX.bodyForRemove}>
                <div className="ml_5 fs-semi-bold f-color fs-18">
                  LinkedIn URL
                </div>
              </DialogContent>
              <DialogActions
                className="responsiveRemove_Modal_button"
                sx={stylesSX.buttonAlignForRemove}
              >
                <div className="linkedin-modal-url-container">
                  <div className="linkedin-modal-url-container">
                    {/* <label className="field_name email-label-form-one" htmlFor="email">Linked In URL</label> */}
                    <input
                      type="text"
                      className="text_box_cleartalent_form1 mb_10"
                      id="email"
                      name="linkedIn"
                      placeholder="Enter LinkedIn URL"
                      value={urlValue}
                      onChange={(e) => setUrlValue(e.target.value)}
                    />
                  </div>
                  <div className="remove_modal">
                    <button
                      type="button"
                      className="btn-big btn-skill cp"
                      onClick={closeLinkedModal}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn-big btn-green ml_10 cp"
                    >
                      Save
                    </button>
                  </div>
                </div>
              </DialogActions>
            </Dialog>
          </div>
        </>
      ) : (
        <>
          <div className="powres_card mt_10 powres_box">
            <div className="row">
              <Skeleton variant="text" animation="wave" />
              <div className="df mt_6">
                <div className="w-100 ml_10">
                  <Skeleton variant="text" animation="wave" />
                </div>
              </div>
              <Skeleton variant="text" animation="wave" />

              <div className="text-right remove-btn-design type_a mt_10 float_none">
                <Skeleton variant="text" animation="wave" />
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};
export default Resume;

